<div class="mini-wrapper">
  <div class="sub-wrapper">
    <h1 class="landing text-center mb-4">{{ 'changePasswordCompleteComponent.title' | transloco }}</h1>
    <div class="mt-3 mb-4">
      <div class="translate">{{ 'changePasswordCompleteComponent.info' | transloco }}</div>
    </div>
    <div class="mt-2 d-flex">
      <button
        [routerLink]="['/logout']"
        class="secondary xl me-3 ms-auto"
        disableRipple
        mat-button
        data-test="change-password-complete_btn-goto-profile"
      >
        <svg-icon key="arrowLeft" class="m"></svg-icon>
        {{ 'changePasswordCompleteComponent.goTo' | transloco }}
      </button>
    </div>
  </div>
</div>
